import {
  Id,
  PinnedMessagesData,
  MessagesResponse as Response,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from 'chat/shared/queries/keys'
import { produce } from 'immer'

type Variables = {
  conversationId: Id
  messageId: Id
}
export function useUnpinMessage(id: Id) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: unpinMessage,
    onSuccess: async (_, { messageId }) => {
      const key = keys.pinnedMessages(id)
      const data = client.getQueryData<PinnedMessagesData>(key)
      if (!data) {
        return
      }
      const index = data.pinnedMessages.findIndex(m => m.id === messageId)
      if (index < 0) {
        return
      }

      await client.cancelQueries({ queryKey: key })
      client.setQueryData<PinnedMessagesData>(
        key,
        produce(data, updatedData => {
          updatedData.pinnedMessages.splice(index, 1)
        })
      )
    },
  })

  function unpinMessage({ conversationId, messageId }: Variables) {
    return server.delete<Response.PinnedMessageResponse>(
      `/v2/chat/conversations/${conversationId}/messages/${messageId}/pinned`
    )
  }
}
